import { ref, onMounted } from 'vue';

export function useSpeechSynthesis() {
  const selectedVoice = ref(null);
  const voicesLoaded = ref(false);

  const setupVoices = () => {
    const checkVoices = () => {
      const voices = window.speechSynthesis.getVoices();

      console.table(
        voices.map((v) => ({
          name: v.name,
          lang: v.lang,
          default: v.default,
        }))
      );

      if (voices.length === 0) {
        setTimeout(checkVoices, 100); // Retry
        return;
      }

      const englishVoices = voices.filter(
        (voice) => voice.lang === 'en-US' && voice.name === 'Google US English'
      );

      const genericEnglishVoices = voices.filter((voice) =>
        voice.lang.startsWith('en-US')
      );

      selectedVoice.value =
        englishVoices[0] ||
        genericEnglishVoices[0] ||
        voices.find((v) => v.default) ||
        voices[0];

      voicesLoaded.value = true;
    };

    if (
      typeof speechSynthesis !== 'undefined' &&
      speechSynthesis.onvoiceschanged !== undefined
    ) {
      speechSynthesis.onvoiceschanged = checkVoices;
    }

    checkVoices();
  };

  const speakOutLoud = (item) => {
    if (!selectedVoice.value || !item) return;

    const utteranceText = item.toString().toLowerCase();
    const utterance = new SpeechSynthesisUtterance(utteranceText);
    utterance.pitch = 1.2;
    utterance.rate = 0.8;
    utterance.voice = selectedVoice.value;

    window.speechSynthesis.speak(utterance);
  };

  onMounted(() => {
    setupVoices();
  });

  return {
    selectedVoice,
    voicesLoaded,
    speakOutLoud,
  };
}
